import MesTachesWidget from '@/components/MesTachesWidget';

export default function MesTachesPage() {
  return (
    <div className="p-6 lg:p-8 max-w-4xl mx-auto" data-testid="mes-taches-page">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-slate-900">📋 Mes tâches</h1>
        <p className="text-slate-600 mt-2">
          Toutes les tâches qui te sont assignées (par Fred, par Valentine ou par les agents IA).
        </p>
      </div>
      <MesTachesWidget compact={false} />
    </div>
  );
}
